import clsx from 'clsx';
import { ReactElement, useMemo } from 'react';

import { Button, CustomCSSProperties } from '@vestico/shared';
import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import style from './OverlayIcon.module.css';

export type OverlayIconSize = 'default' | 'small';
export type OverlayIconColorScheme = 'light' | 'dark';

export interface OverlayIconProps {
  icon: ReactElement;
  fillIcon?: boolean;
  text: string | null | undefined;
  onClick: () => void;
}

export interface GenericOverlayIconProps {
  size?: OverlayIconSize;
  colorScheme?: OverlayIconColorScheme;
  disableShadows?: boolean;
  looseWidth?: boolean;
  customIcon?: boolean; // Set true for non SVG items
  ariaLabel?: string;
}

export const OverlayIcon = ({
  icon,
  fillIcon,
  text,
  size,
  colorScheme,
  looseWidth,
  disableShadows,
  onClick,
  customIcon,
  ariaLabel,
}: OverlayIconProps & GenericOverlayIconProps) => {
  const iconSize = useMemo(() => (size === 'small' ? '24px' : '40px'), [size]);

  return (
    <div
      className={clsx(
        style.root,
        { [style.shadows]: !disableShadows, [style.loose]: looseWidth },
        { [style.dark]: colorScheme === 'dark' },
        { [style.fill]: fillIcon },
        { [style.svg]: !customIcon }
      )}
      style={{ '--icon-size': iconSize } as CustomCSSProperties}
    >
      <Button
        onClick={onClick}
        plain
        light
        noPadding
        ariaLabel={ariaLabel ?? text}
        content={
          <div className={clsx(style.content)}>
            {icon}
            {text && text.length > 0 ? (
              <div className={clsx(globalStyle.textXSmall, globalStyle.textBold, style.text, { [style.shadows]: !disableShadows })}>{text}</div>
            ) : null}
          </div>
        }
      />
    </div>
  );
};
